function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "b"
}, React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#b)",
  fill: "#FBBC05",
  d: "M0 37V11l17 13z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#b)",
  fill: "#EA4335",
  d: "M0 11l17 13 7-6.1L48 14V0H0z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#b)",
  fill: "#34A853",
  d: "M0 37l30-23 7.9 1L48 0v48H0z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#b)",
  fill: "#4285F4",
  d: "M48 48L17 24l-4-3 35-10z"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.686f8efa.svg";
export { ForwardRef as ReactComponent };